export default {
  props: {
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    },
    themeColor: {
      type: String,
      default: ''
    },
    pageDescription: {
      type: Boolean,
      default: false
    },
    itemIndex: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Number
    },
    arrNum: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Number
    },
    pageDescriptionConfig: {
      type: Object
    }
  },
  data() {
    return {
      premiumShow: false
    };
  },
  methods: {
    premiumFun() {}
  }
};